  import React from 'react';
import '../less/main.less';
import DOMPurify from 'utils/sanitize';
import { Link } from 'MWC';

export default function template() {
  const { items, title, className, subtitle, itemTitleTag, subtitleTag } = this.props;

  const ItemTitleTag = itemTitleTag || 'h3';

  const SubtitleTag = subtitleTag || 'h3';

  return (
    <div className={`advantages advantages_${items.length}${className ? ` ${className}` : ''}`}>
      <div className="container">
        {title && <h2 className="advantages__title">{this.l10n(title)}</h2>}
          {subtitle && <SubtitleTag className="advantages__subtitle" dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(this.l10n(subtitle)) }}></SubtitleTag>}
        <div className="advantages__row">
          {items.map((item, index) => {
            const content = (
              <>
                {item.img && <img className="item-advantages__image" src={item.img} alt={`image ${index + 1}`} />}
                <div className="item-advantages__body">
                  {item.title && <ItemTitleTag className="item-advantages__title title-item-advantages" dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(this.l10n(item.title))}}></ItemTitleTag>}
                  <div
                    className="item-advantages__text text-item-advantages"
                    dangerouslySetInnerHTML={{
                      __html: DOMPurify.sanitize(this.l10n(item.text), {
                        ADD_ATTR: ['target', 'rel']
                      })
                    }}
                  ></div>
                </div>
              </>
            );

            const className = `advantages__item item-advantages item-advantages_${item.type ? item.type : index + 1}`;

            return item.link ? (
              <Link
                href={item.link}
                onClick={e => this.navigate(item.link, e)}
                className={className}
                key={index}
              >
                {content}
              </Link>
            ) : (
              <div className={className} key={index}>
                {content}
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
